// @flow
import AuthedRoute from './AuthedRoute';
export default AuthedRoute;
